var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProtectImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80081 10.7767C4.80081 10.7767 5.29506 11.0374 5.75961 11.1917C5.75961 11.1917 6 11.2782 6.24039 11.1917C6.24039 11.1917 6.70494 11.0374 7.19919 10.7767C7.19919 10.7767 7.99374 10.3575 8.62464 9.77691C8.62464 9.77691 10.5 8.05106 10.5 5.37656V2.625C10.5 2.625 10.5 2.31434 10.2803 2.09467C10.2803 2.09467 10.0607 1.875 9.75 1.875H2.25C2.25 1.875 1.93934 1.875 1.71967 2.09467C1.71967 2.09467 1.5 2.31434 1.5 2.625V5.37656C1.5 5.37656 1.5 8.05106 3.37536 9.77691C3.37536 9.77691 4.00626 10.3575 4.80081 10.7767ZM6.84925 10.1133C6.84925 10.1133 6.40762 10.3463 6 10.4813C6 10.4813 5.59239 10.3463 5.15075 10.1133C5.15075 10.1133 4.44241 9.73964 3.88324 9.22504C3.88324 9.22504 2.25 7.72201 2.25 5.37656V2.625H9.75V5.37656C9.75 5.37656 9.75 7.72201 8.11677 9.22504C8.11677 9.22504 7.55758 9.73964 6.84925 10.1133Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#94A3BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19658 5.91639C4.12681 5.84971 4.03401 5.8125 3.9375 5.8125C3.93742 5.8125 3.92899 5.8126 3.92899 5.8126C3.82956 5.81485 3.7351 5.85651 3.66639 5.92842C3.59971 5.99819 3.5625 6.09099 3.5625 6.1875L3.5626 6.19601C3.56485 6.29544 3.60651 6.3899 3.67842 6.45861L5.05186 7.77111C5.19672 7.90954 5.42481 7.90964 5.56979 7.77133L8.32126 5.14642C8.39322 5.07777 8.43506 4.98325 8.4374 4.88382C8.43754 4.87782 8.43753 4.87181 8.43739 4.86581C8.4351 4.77261 8.39818 4.6836 8.33383 4.61615C8.26307 4.54197 8.16502 4.5 8.0625 4.5L8.05192 4.50015C7.95921 4.50277 7.87076 4.53965 7.80365 4.60367L5.31116 6.98151L4.19658 5.91639Z",
    fill: "#94A3BD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectImg);
export default __webpack_public_path__ + "static/media/protect-img.6d9b833114b79d0ec4dba9c2e0e01ff4.svg";
export { ForwardRef as ReactComponent };